import { fetcher } from 'api'
import { getUser } from 'helpers/storage'
import { useAppStore } from 'store'
import { CreateContent } from 'types/app'

type MeetingData = {
	attendeeId: string
	externalUserId: string
	joinToken: string
	capabilities: {
		audio: string
		content: string
		video: string
	}
	meetingId: string
	contentId: string
}

export const startRecording = (
	meetingId: string,
	contentId: string,
): Promise<void> => {
	const { endpoints } = useAppStore.getState()
	const url =
		endpoints?.CustomApplicationContentLiveSessionUrl +
		'/' +
		meetingId +
		'/Record'

	const payload = {
		meetingId,
		contentId,
	}

	return fetcher(url, { method: 'post', body: JSON.stringify(payload) })
}

export const finishRecording = (meetingId: string): Promise<void> => {
	const { endpoints } = useAppStore.getState()
	const url =
		endpoints?.CustomApplicationContentLiveSessionUrl + '/' + meetingId

	return fetcher(url, { method: 'delete' })
}

export const createRecordingContent = (): Promise<
	CreateContent & {
		id: string
		properties: {
			'Content:Process:SessionId': string
		}
	}
> => {
	const { endpoints } = useAppStore.getState()
	const url = endpoints?.CustomApplicationContentLiveSessionUrl + '/Create'

	const payload = {
		originalLanguage: 'en-US',
		type: 'CameraCapture',
		published: false,
		originalTitle:
			getUser()?.['Custom:User:Name'] +
			' - Validation - ' +
			new Date().toLocaleString(),
	}

	return fetcher(url, { method: 'post', body: JSON.stringify(payload) })
}

export const getMeetingData = (meetingId: string): Promise<MeetingData> => {
	const { endpoints } = useAppStore.getState()
	const url =
		endpoints?.CustomApplicationContentLiveSessionUrl + '/' + meetingId

	return fetcher(url, { method: 'get' })
}

export const getAttendeeData = (meetingId: string): Promise<MeetingData> => {
	const { endpoints } = useAppStore.getState()
	const url =
		endpoints?.CustomApplicationContentLiveSessionUrl +
		'/' +
		meetingId +
		'/Connect'

	return fetcher(url, { method: 'put' })
}
